import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { APP_CONSTANTS } from 'src/app/core/constants/enum.constants';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-pagination',
    standalone: true,
    imports: [CommonModule, NgbPaginationModule],
    template: `
        <div [ngClass]="{ 'mt-2': totalItems > pageSize }">
            <ngb-pagination
                *ngIf="totalItems > pageSize"
                class="ngb-pagination mt-2"
                [rotate]="true"
                [(page)]="page"
                [pageSize]="pageSize"
                [ellipses]="!isMobile"
                [boundaryLinks]="isMobile"
                [directionLinks]="!isMobile"
                [collectionSize]="totalItems"
                [maxSize]="maxPaginationElements"
                (pageChange)="pageChangeEvent($event)">
                <ng-container *ngIf="!isMobile">
                    <ng-template ngbPaginationPrevious>
                        <em class="flaticon-left-chevron-1"></em>
                    </ng-template>
                    <ng-template ngbPaginationNext>
                        <em class="flaticon-right-chevron"></em>
                    </ng-template>
                </ng-container>
            </ngb-pagination>
        </div>
    `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaginationComponent {
    @Input() totalItems!: number;
    @Input() page!: number;
    @Input() isMobile!: boolean;
    @Output() pageChange = new EventEmitter<number>();

    pageSize = +APP_CONSTANTS.TABLE_PAGE_LIMIT;
    maxPaginationElements = +APP_CONSTANTS.MAX_PAGINATION_ELEMENTS;

    pageChangeEvent(pageNumber: number) {
        this.pageChange.emit(pageNumber);
    }
}
